import React from "react";
import {connect} from "react-redux";
import {RouteComponentProps} from "react-router";
import {css, Theme} from "@emotion/react";
import {bindActionCreators, Dispatch} from "redux";

import {Container} from "@pg-design/grid-module";
import {backgroundColor, p} from "@pg-design/helpers-css";
import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FaqSection} from "@pg-mono/faq";
import {FormActions} from "@pg-mono/form";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {VendorLinks} from "../../atoms/VendorLinks";
import {IFaqStore} from "../../faq/reducers/faq_reducer";
import {IRecommendedRegionVendors} from "../actions/fetch_recommended_regions_vendors";
import {IVendorsNearbyRegion} from "../actions/fetch_vendor_nearby_regions_vendors";
import {vendorListSearchFormActions} from "../actions/fetch_vendor_search_lists";
import {VendorListListSection} from "../components/list/VendorListListSection";
import {VendorListSeoDescription} from "../components/list/VendorListSeoDescription";
import {vendorSearchFormFields} from "../components/SearchVendor";
import {VendorBreadcrumbs} from "../components/VendorBreadcrumbs";
import {calculateVendorListMaxPage} from "../helpers/calculate_vendor_list_max_page";
import {IVendorListStore} from "../reducers/vendor_list_reducer";

interface IStateProps {
    vendorList: IVendorListStore;
    recommendedRegions: IRecommendedRegionVendors[];
    nearbyRegions: IVendorsNearbyRegion[];
    faq: IFaqStore;
}

interface IActionProps {
    formActions: FormActions<Record<keyof typeof vendorSearchFormFields, unknown>>;
}

interface IOwnProps extends RouteComponentProps<{}> {}

interface IProps extends IStateProps, IActionProps, IOwnProps {}

const VendorListC: React.FC<IProps> = (props) => {
    const {isMobile} = useUserDevice();

    const query = parseSearch(props.location.search);
    const currentPage = typeof query.page === "string" ? parseInt(query.page, 10) : 1;

    const getPageLink = (page: number) => {
        const query = validateQuery(["page"], parseSearch(props.location.search), page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(props.location.pathname, query);
    };
    const maxPage = calculateVendorListMaxPage(props.vendorList);

    const nearbyRegionsWithActiveVendors = props.nearbyRegions.filter((region) => region.stats.vendors_count_for_sale > 0);
    const recommendedRegionVendorsWithActiveVendors = props.recommendedRegions.filter((region) => region.stats.vendors_count_for_sale > 0);

    const areThereAnyVendorsInOtherLocationsToShow = nearbyRegionsWithActiveVendors.length + recommendedRegionVendorsWithActiveVendors.length > 0;

    return (
        <>
            <article css={articleStyle}>
                <Container>
                    <VendorBreadcrumbs />
                </Container>

                <VendorListListSection list={props.vendorList} />

                <Container css={paginationContainerStyles}>
                    <Pagination
                        getPageLink={getPageLink}
                        pageCount={maxPage}
                        currentPage={currentPage}
                        size={isMobile ? PaginationSize.MD : PaginationSize.LG}
                        siblingsCount={isMobile ? 0 : 1}
                    />
                </Container>

                {props.vendorList.page === 1 && props.vendorList.regionSEOMetadata?.description && (
                    <Container>
                        <VendorListSeoDescription seo_description={props.vendorList.regionSEOMetadata.description} />
                    </Container>
                )}
                {currentPage === 1 && <FaqSection faqContent={props.faq.data} />}
            </article>

            {areThereAnyVendorsInOtherLocationsToShow && (
                <VendorLinks
                    region={props.vendorList.region?.[0]}
                    recommendedRegions={recommendedRegionVendorsWithActiveVendors}
                    nearbyRegions={nearbyRegionsWithActiveVendors}
                />
            )}
        </>
    );
};

export const VendorListView = connect<IStateProps, IActionProps, IOwnProps, IRPStore>(mapStateToProps, mapActionsToProps)(VendorListC);

/**
 * Connect
 */
function mapStateToProps(store: IRPStore): IStateProps {
    return {
        vendorList: store.vendor.list,
        nearbyRegions: store.vendor.recommendedRegionVendors.nearbyRegions,
        recommendedRegions: store.vendor.recommendedRegionVendors.recommendedRegions,
        faq: store.faq
    };
}

function mapActionsToProps(dispatch: Dispatch): IActionProps {
    return {
        formActions: bindActionCreators({...vendorListSearchFormActions}, dispatch)
    };
}

const articleStyle = (theme: Theme) => css`
    ${backgroundColor(theme.colors.gray["100"])};
`;

const paginationContainerStyles = (theme: Theme) => css`
    ${p(5, 0)};

    @media (min-width: ${theme.breakpoints.lg}) {
        ${p(6, 0)};
    }
`;
import React from "react";
import {connect} from "react-redux";
import {RouteComponentProps} from "react-router";
import {css, Theme} from "@emotion/react";
import {bindActionCreators, Dispatch} from "redux";

import {Container} from "@pg-design/grid-module";
import {backgroundColor, p} from "@pg-design/helpers-css";
import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FaqSection} from "@pg-mono/faq";
import {FormActions} from "@pg-mono/form";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {VendorLinks} from "../../atoms/VendorLinks";
import {IFaqStore} from "../../faq/reducers/faq_reducer";
import {IRecommendedRegionVendors} from "../actions/fetch_recommended_regions_vendors";
import {IVendorsNearbyRegion} from "../actions/fetch_vendor_nearby_regions_vendors";
import {vendorListSearchFormActions} from "../actions/fetch_vendor_search_lists";
import {VendorListListSection} from "../components/list/VendorListListSection";
import {VendorListSeoDescription} from "../components/list/VendorListSeoDescription";
import {vendorSearchFormFields} from "../components/SearchVendor";
import {VendorBreadcrumbs} from "../components/VendorBreadcrumbs";
import {calculateVendorListMaxPage} from "../helpers/calculate_vendor_list_max_page";
import {IVendorListStore} from "../reducers/vendor_list_reducer";

interface IStateProps {
    vendorList: IVendorListStore;
    recommendedRegions: IRecommendedRegionVendors[];
    nearbyRegions: IVendorsNearbyRegion[];
    faq: IFaqStore;
}

interface IActionProps {
    formActions: FormActions<Record<keyof typeof vendorSearchFormFields, unknown>>;
}

interface IOwnProps extends RouteComponentProps<{}> {}

interface IProps extends IStateProps, IActionProps, IOwnProps {}

const VendorListC: React.FC<IProps> = (props) => {
    const {isMobile} = useUserDevice();

    const query = parseSearch(props.location.search);
    const currentPage = typeof query.page === "string" ? parseInt(query.page, 10) : 1;

    const getPageLink = (page: number) => {
        const query = validateQuery(["page"], parseSearch(props.location.search), page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(props.location.pathname, query);
    };
    const maxPage = calculateVendorListMaxPage(props.vendorList);

    const nearbyRegionsWithActiveVendors = props.nearbyRegions.filter((region) => region.stats.vendors_count_for_sale > 0);
    const recommendedRegionVendorsWithActiveVendors = props.recommendedRegions.filter((region) => region.stats.vendors_count_for_sale > 0);

    const areThereAnyVendorsInOtherLocationsToShow = nearbyRegionsWithActiveVendors.length + recommendedRegionVendorsWithActiveVendors.length > 0;

    return (
        <>
            <article css={articleStyle}>
                <Container>
                    <VendorBreadcrumbs />
                </Container>

                <VendorListListSection list={props.vendorList} />

                <Container css={paginationContainerStyles}>
                    <Pagination
                        getPageLink={getPageLink}
                        pageCount={maxPage}
                        currentPage={currentPage}
                        size={isMobile ? PaginationSize.MD : PaginationSize.LG}
                        siblingsCount={isMobile ? 0 : 1}
                    />
                </Container>

                {props.vendorList.page === 1 && props.vendorList.regionSEOMetadata?.description && (
                    <Container>
                        <VendorListSeoDescription seo_description={props.vendorList.regionSEOMetadata.description} />
                    </Container>
                )}
                {currentPage === 1 && <FaqSection faqContent={props.faq.data} />}
            </article>

            {areThereAnyVendorsInOtherLocationsToShow && (
                <VendorLinks
                    region={props.vendorList.region?.[0]}
                    recommendedRegions={recommendedRegionVendorsWithActiveVendors}
                    nearbyRegions={nearbyRegionsWithActiveVendors}
                />
            )}
        </>
    );
};

export const VendorListView = connect<IStateProps, IActionProps, IOwnProps, IRPStore>(mapStateToProps, mapActionsToProps)(VendorListC);

/**
 * Connect
 */
function mapStateToProps(store: IRPStore): IStateProps {
    return {
        vendorList: store.vendor.list,
        nearbyRegions: store.vendor.recommendedRegionVendors.nearbyRegions,
        recommendedRegions: store.vendor.recommendedRegionVendors.recommendedRegions,
        faq: store.faq
    };
}

function mapActionsToProps(dispatch: Dispatch): IActionProps {
    return {
        formActions: bindActionCreators({...vendorListSearchFormActions}, dispatch)
    };
}

const articleStyle = (theme: Theme) => css`
    ${backgroundColor(theme.colors.gray["100"])};
`;

const paginationContainerStyles = (theme: Theme) => css`
    ${p(5, 0)};

    @media (min-width: ${theme.breakpoints.lg}) {
        ${p(6, 0)};
    }
`;
